import classNames from 'classnames';
import { Accordion } from 'react-bootstrap';
import CategoryFilterBreadcrumbs from 'components/CategoryFilterBreadcrumbs';
import CategoryFilterList from 'components/CategoryFilterList';
import { transformFacetName } from 'data/dutchie/transformations';
import parseFacetVisibility from 'utils/parse-facet-visibility';
import styles from './CategoryFilters.module.scss';

function CategoryFilters({
  category,
  closeoutText,
  facets,
  filterParam = '',
  path,
  promotion,
  searchParam = '',
  title,
}) {
  const { sanitizedParams, visibleFilterCount } = parseFacetVisibility(
    facets,
    filterParam
  );

  return (
    <div className={classNames('d-none d-md-block mb-16', styles.filter_list)}>
      {visibleFilterCount || promotion || searchParam ? (
        <CategoryFilterBreadcrumbs
          category={category}
          facets={facets}
          filterParam={filterParam}
          path={path}
          promotion={promotion}
          searchParam={searchParam}
          title={title}
        />
      ) : null}
      {facets.map((facet) => {
        if (!facet || !facet.facet || !facet.value || !facet.visible) {
          return null;
        }

        const { ranges: unsanitizedRanges, terms: unsanitizedTerms } =
          facet.value;
        const ranges = unsanitizedRanges || [];
        const terms = (unsanitizedTerms || []).filter(({ term }) => term);

        if (ranges.length === 0 && terms.length === 0) {
          return null;
        }

        const { facet: facetName, value } = facet;
        return (
          <div
            key={`${facetName}${path}`}
            data-value="facet-block"
            className="border-bottom mb-5 pb-5 me-10"
          >
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header data-value="facet-name">
                  {transformFacetName(facetName)}
                </Accordion.Header>
                <Accordion.Body>
                  <CategoryFilterList
                    closeoutText={closeoutText}
                    facet={facetName}
                    filterParam={sanitizedParams.join(',')}
                    filterType={value.type}
                    path={path}
                    promotion={promotion}
                    ranges={value.ranges}
                    terms={value.terms}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        );
      })}
    </div>
  );
}

export default CategoryFilters;
